import { defineMessages } from 'react-intl';

export default defineMessages({
    pleaseSelect: {
        id: 'common.components.wmic-dropdown.Please Select',
        defaultMessage: 'Please Select'
    }
});